<template>
    <div>
        <b-btn v-b-modal.customerFinder size="sm" variant="link" class="color-blue">
            Postcode Quantity Lookup
            <i class="fa fa-search fa-lg" aria-hidden="true"></i>
        </b-btn>
        <b-modal id="customerFinder" ref="customerFinder" size="lg" hide-header hide-footer @hidden="refresh">
            <div class="full">
                <iframe ref="finder" src="https://www.ukchanges.com/royalmail/door_to_door/find_customers.asp" frameborder="0"></iframe>
            </div>
            <button ref="modalClose" type="button" class="btn modal-close" @click="close">
                <i class="fa fa-times fa-lg" aria-hidden="true"></i>
            </button>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'customer-finder',
    methods: {
        refresh() {
            this.$refs.finder.src = this.$refs.finder.src
        },
        close() {
            this.$root.$emit('bv::hide::modal','customerFinder')
            // this.$refs.modalClose.blur()
        }
    }
}
</script>

<style lang="scss" scoped>
.btn-sm {
    font-size: 0.8rem;
}
.full {
    width: 100%;
    height: 90vh;
    & iframe {
        width: 100%;
        height: 100%;
    }
    overflow: scroll;
    -webkit-overflow-scrolling: touch;
}
</style>





// WEBPACK FOOTER //
// src/components/modules/customer-finder/customer-finder.vue